import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { useQuery } from "react-query"
import { RouteComponentProps } from "react-router"
import SideBar from "../../common/layout/sidebar.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import { HttpError } from "../../state/helpers/Error"
import { CreditMemoElastic } from "../../state/listing/credit-memo/models/creditMemoElastic"
import { PaymentElastic } from "../../state/listing/payment/models"
import Payment from "../../state/payment/Payment"
import PaymentService from "../../state/payment/PaymentService"
import PaymentDetailsInfo from "./PaymentDetailsInfo"
import PaymentDetailsRefundListing from "./PaymentDetailsRefundListing"
import PaymentDetailsTransactionListing from "./PaymentDetailsTransactionListing"

type Params = {
    paymentId: string,
}


type FetchedDataState = {
    originalPayment: Payment | HttpError | undefined
    creditMemo: CreditMemoElastic | undefined
    applicationPayments : PaymentElastic[] | undefined
    isLoadingData : boolean
}

const PaymentDetails = (props: RouteComponentProps<Params>) => {
    SideBar.activateMenu("payment")
    const paymentId = props.match.params.paymentId

    const [fetchedData, setFetchedData] = useState<FetchedDataState>({
        creditMemo: undefined,
        originalPayment: undefined,
        applicationPayments : undefined,
        isLoadingData: false
    })


    const { data : payment , isLoading: isLoadingPayment, refetch } = useQuery(["getPayment", paymentId], () => {
        return PaymentService.getPayment(paymentId)
    })


    useEffect(() => {
        if (payment instanceof Payment && !isLoadingPayment) {
            const fetchData = async () => {

                setFetchedData({
                    ...fetchedData,
                    isLoadingData : true
                })
                const [creditMemoData, originalPaymentData, applicationPaymentData] = await Promise.all([
                    PaymentService.getCreditMemoPerPaymentId(payment.getOriginalPaymentId()),
                    PaymentService.getPayment(payment.getOriginalPaymentId()),
                    PaymentService.getPaymentPerOriginalPaymentId(payment.getId())
                ])
                setFetchedData({
                    originalPayment : originalPaymentData,
                    creditMemo : creditMemoData,
                    applicationPayments : applicationPaymentData,
                    isLoadingData : false
                })
            }
            fetchData()
        }
    }, [payment, isLoadingPayment])

    const handleChangeContact = async (contactId: string) => {
        if (payment instanceof Payment && !isLoadingPayment) {
            await PaymentService.updatePayment(payment.getId(), { contactId })
            refetch()
        }
    }

    if (isLoadingPayment || fetchedData.isLoadingData) {
        return <LoadingSpinner className="py-2" />
    }

    return <>
        <PaymentDetailsInfo
            payment={payment}
            creditMemo={fetchedData.creditMemo}
            originalPayment={fetchedData.originalPayment}
            applicationPayments={fetchedData.applicationPayments}
            onChangeContact={handleChangeContact}
        />
        <PaymentDetailsTransactionListing paymentId={paymentId} />
        <PaymentDetailsRefundListing payment={payment} creditMemo={fetchedData.creditMemo}/>
    </>

}

export default injectIntl(PaymentDetails)


// WEBPACK FOOTER //
// ./src/payment/components/PaymentDetails.tsx